<template>
    <svg viewBox="0 0 41 40" xmlns="http://www.w3.org/2000/svg">
        <circle :class="active ? 'fill-red' : 'fill-gray-300'" cx="20.5" cy="20" r="20" />
        <path
            class="fill-white"
            clip-rule="evenodd"
            d="M11.5085 11.0084C11.9641 10.5528 12.7028 10.5528 13.1584 11.0084L29.4917 27.3417C29.9473 27.7973 29.9473 28.536 29.4917 28.9916C29.0361 29.4472 28.2974 29.4472 27.8418 28.9916L11.5085 12.6583C11.0528 12.2027 11.0528 11.464 11.5085 11.0084Z"
            fill-rule="evenodd"
        />
        <path
            class="fill-white"
            clip-rule="evenodd"
            d="M11.5083 28.9916C11.0527 28.536 11.0527 27.7973 11.5083 27.3417L27.8416 11.0084C28.2972 10.5528 29.0359 10.5528 29.4915 11.0084C29.9472 11.464 29.9472 12.2027 29.4915 12.6583L13.1582 28.9916C12.7026 29.4472 11.9639 29.4472 11.5083 28.9916Z"
            fill-rule="evenodd"
        />
    </svg>
</template>
<script setup>
defineProps({
    active: { type: Boolean, default: false },
});
</script>
